import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'
import { Box } from '@chakra-ui/react'

interface CustomIconProps extends IconProps {
  variant?: string
}

const ClipboardWithCheckOutline = createIcon({
  displayName: 'ClipboardWithCheckOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24H0Z" />
        <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
          <rect width="8" height="4" x="8" y="3" rx="1" />
          <path d="M16 5h2l-.01 0c1.1-.01 2 .89 2 1.99v12 0c0 1.1-.9 2-2 2h-12l-.01-.001c-1.11-.01-2-.9-2-2.01 0 0 0 0 0 0v-12l0 0c-.01-1.11.89-2.01 1.99-2.01h2" />
          <path d="M14.23 12.85l-2.79 2.79 -1.68-1.68" />
        </g>
      </g>
    </>
  ),
})

const ClipboardWithCheckTwoTone = createIcon({
  displayName: 'ClipboardWithCheckTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" fill="none">
        <path d="M0 0h24v24H0Z" />
        <Box
          as="path"
          fill="light"
          stroke="twoToneStrokeColor"
          d="M16 5h2l-.01 0c1.1-.01 2 .89 2 1.99v12 0c0 1.1-.9 2-2 2h-12l-.01-.001c-1.11-.01-2-.9-2-2.01 0 0 0 0 0 0v-12l0 0c-.01-1.11.89-2.01 1.99-2.01h2"
        />
        <Box as="g" strokeLinecap="round" strokeWidth="1.5" stroke="twoToneStrokeColor" fill="twoToneFillColor" strokeLinejoin="round">
          <rect width="8" height="4" x="8" y="3" rx="1" />

          <Box as="path" fill="light" stroke="twoToneStrokeColor" d="M14.23 12.85l-2.79 2.79 -1.68-1.68" />
        </Box>
      </Box>
    </>
  ),
})

const ClipboardWithCheck: FC<CustomIconProps> = (props) => {
  if (props.variant === 'twoTone') return <CustomIcon as={ClipboardWithCheckTwoTone} {...props} />

  return <CustomIcon as={ClipboardWithCheckOutline} {...props} />
}

export default memo(ClipboardWithCheck)
